export default __webpack_public_path__ + "static/media/nav-left.8b936ea6.svg";